// Global constants file
// All const should be a const and be a value that doesn't change.
// If it's a function, please use the components/helpers file
// please follow the upper case pattern. Comments always welcome.

export const MONTHLY_PRICE_PLAN = 9.99;
export const ANNUAL_PRICE_AS_YEARLY = 39.99;
export const SINGLE_ICON_PRICE = 2.99;
// comes out as 3.3325. This # is important for calcs for subscriptions that product wants
export const ANNUAL_PRICE_AS_MONTHLY = 39.99 / 12;

export const CENTS = "cents";
export const PERCENT = "percent";

export const SUBTEXT_ANNUAL_TEAM_PLAN = "/month per user paid yearly";
export const SUBTEXT_ANNUAL_TEAM_PLAN_AS_MONTHLY = "/month per user";
export const SUBTEXT_ANNUAL_PLAN_AS_MONTHLY = "/month paid yearly";
export const SUBTEXT_ANNUAL_EDU_PLAN = "/year per user";
export const SUBTEXT_MONTHLY_PLAN = "/month";

export const PER_MONTH = "/month";
export const PER_YEAR = "/year";

export const YEARLY_PLAN_TYPE = "yearly";

export const YEARLY_SUBSCRIPTION_PLAN_NAME = "Yearly NounPro Unlimited";
export const MONTHLY_SUBSCRIPTION_PLAN_NAME = "Monthly NounPro Unlimited";

export const ICONS = "icons";
export const COLLECTIONS = "icon-collections";
export const PHOTOS = "photos";

export const BROWSE_LIST_TYPE = "browse";
export const SEARCH_LIST_TYPE = "search";

export const PROD_BASE_URL = "https://thenounproject.com";
